export default __webpack_public_path__ + "static/dsta2018-1d8d960635b1440cc9c881ef0235a520.jpg";